export const cookieLanguageRegex =
  /(?:^|;)\s*django_language=([a-z]{2})\s*(?:;|$)/;

export function getLanguage() {
  const cookieMatch = cookieLanguageRegex.exec(document.cookie);
  const cookieLang = cookieMatch && cookieMatch[1];
  return cookieLang || document.documentElement.lang || 'en';
}

export function setLanguageCookie(lang) {
  document.cookie = 'django_language=' + lang;
}
